import { Injectable } from "@angular/core";
import { FacebookLoginPlugin } from '@capacitor-community/facebook-login';
import { isPlatform } from '@ionic/angular';
import { Plugins, registerWebPlugin } from '@capacitor/core';
import { AngularFireAuth } from "@angular/fire/auth";
import { BehaviorSubject } from "rxjs";
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/database';
import { AngularFirestore } from "@angular/fire/firestore";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { FacebookLogin } from '@capacitor-community/facebook-login';
//registerWebPlugin(FacebookLogin);
export class AuthInfo {
  constructor(public $uid: string) { }

  isLoggedIn() {
    return !!this.$uid;
  }
}

@Injectable({
  providedIn: "root",
})
export class ApisService {
  
  fbLogin: FacebookLoginPlugin;
  user = null;
  token = null;
  static UNKNOWN_USER = new AuthInfo(null);
  db = firebase.firestore();
  selectedCity: any;
  public authInfo$: BehaviorSubject<AuthInfo> = new BehaviorSubject<AuthInfo>(
    ApisService.UNKNOWN_USER
  );
  constructor(
    private fireAuth: AngularFireAuth,
    private adb: AngularFirestore,
    private http: HttpClient
  ) { 
    this.setupFbLogin();}


  async setupFbLogin() {
      this.fbLogin = FacebookLogin;
  }
 
  async loginF() {
    const FACEBOOK_PERMISSIONS = ['email'];
    
    return new Promise<any>((resolve, reject) => {
    this.fbLogin.login({ permissions: FACEBOOK_PERMISSIONS }).then((response) => {
      var token = response.accessToken
      console.log("token")
      console.log(token)
      const facebookCredential = firebase.auth.FacebookAuthProvider.credential(token.token);
      this.fireAuth.auth.signInAndRetrieveDataWithCredential(facebookCredential).then((res) => {
        if (res.user) {
          this.db
            .collection("users")
            .doc(res.user.uid)
            .update({
              fcm_token: localStorage.getItem("fcm")
                ? localStorage.getItem("fcm")
                : "",
            });
          localStorage.setItem("uid", res.user.uid);
          this.authInfo$.next(new AuthInfo(res.user.uid));
          console.log("ressssssssss")
          console.log(res)
          resolve(res);
        }
      })
      .catch((err) => {
        this.authInfo$.next(ApisService.UNKNOWN_USER);
        reject(`login failed ${err}`);
      });
    })
  })
  /* console.log("result")
  //console.log(result)
  return new Promise<any>((resolve, reject) => {
      console.log("this.token weeeeeeeeb")
      console.log(this.token)
      // Web only gets the token but not the user ID
      // Directly call get token to retrieve it now
      
      console.log("getCurrentToken")

      this.getCurrentToken()
      .then(result => {
        console.log("result/////////")
        console.log(result)
        if (result && result != null) {
          localStorage.setItem('uid', result.id);
          this.adb
            .doc(`users/${result.id}`)
            .get()
            .subscribe((response: any) => {
              if (response) {
                if (response.exists) {
                  console.log("user exist",response.data());
                  resolve(response.data());
                }
                else {
                  console.log(result);
                  const data = {
                    uid: result.id,
                    email: result.email,
                    fullname: result.name,
                    type: "active",
                    phone: result.phoneNumber,
                    emailVerified: result.emailVerified,
                    fcm_token: localStorage.getItem("fcm")
                      ? localStorage.getItem("fcm")
                      : "",
                  }
                  console.log(data);
                  this.adb
                    .doc(`users/${result.id}`)
                    .set(data, { merge: false })
                    .then(res => {
                      console.log(res);
                      localStorage.setItem("uid", data.uid);
                      resolve(result)
                    }).catch(err => {
                      resolve(false);
                    })
                  console.log("login success");
                  console.log(this.fireAuth.auth.currentUser);
                }
              }
            });
        }
        else {
          resolve({result : false});
          console.log("something went wrong")
        }
      }).catch(err => {
        reject(err);
        console.log(err);
      })
    }); */
  }
 
  async getCurrentToken() {    
    /* console.log("getCurrentToken")
    const result = await this.fbLogin.getCurrentAccessToken();
    console.log("result")
    console.log(result)
    if (result.accessToken) {
      console.log("result.accessToken")
      console.log(result.accessToken)
      this.token = result.accessToken;
      var UserData = await this.loadUserData(); 
      console.log("UserData//////")
      console.log(UserData)
      return UserData
    } else {
      // Not logged in.
      return null
    } */
    
    return new Promise<any>((resolve, reject) => {
      this.fbLogin.getCurrentAccessToken().then((result) => {
        this.token = result.accessToken;
        this.loadUserData().then((result) => {
          console.log("result loadUserData")
          console.log(result)
            resolve(result)
        });
      });
            /* if (result.accessToken) {
              console.log("result.accessToken")
              console.log(result.accessToken)
              this.token = result.accessToken;
              resolve(this.loadUserData());
            }else{
            reject(false);
          } */
    });

  }
 
  async loadUserData(): Promise<any> {
    console.log("loadUserData")
    const url = `https://graph.facebook.com/${this.token.userId}?fields=id,name,picture.width(720),birthday,email&access_token=${this.token.token}`;
    return new Promise<any>((resolve, reject) => {
      this.http.get(url).subscribe(res => {
        console.log("res")
        console.log(res)
        this.user = res;
        resolve(this.user);
      });
    });
  }
 
  async logoutF() {
    await this.fbLogin.logout();
    this.user = null;
    this.token = null;
  }

  public checkAuth() {
    return new Promise((resolve, reject) => {
      if (localStorage.getItem('uid')) {
      this.getProfile(localStorage.getItem('uid'))
        .then(user => {
          if (user) {
            resolve(user);
          }
          else {
            resolve(false);
          }
        })
        .catch(err => {
          reject(err);
        });
      }
      else {
        resolve(false);
      }
    });
  }

  public login(email: string, password: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.fireAuth.auth
        .signInWithEmailAndPassword(email, password)
        .then((res) => {
          if (res.user) {
            this.db
              .collection("users")
              .doc(res.user.uid)
              .update({
                fcm_token: localStorage.getItem("fcm")
                  ? localStorage.getItem("fcm")
                  : "",
              });
            localStorage.setItem("uid", res.user.uid);
            this.authInfo$.next(new AuthInfo(res.user.uid));
            resolve(res.user);
          }
        })
        .catch((err) => {
          this.authInfo$.next(ApisService.UNKNOWN_USER);
          reject(`login failed ${err}`);
        });
    });
  }

  public getCities(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("cities")
        .get()
        .subscribe(
          (venue: any) => {
            let data = venue.docs.map((element) => {
              let item = element.data();
              item.id = element.id;
              return item;
            });
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public register(
    email: string,
    password: string,
    fullname: string,
    phone: string,
    countryCode: string
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.fireAuth.auth
        .createUserWithEmailAndPassword(email, password)
        .then((res) => {
          if (res.user) {
            this.db
              .collection("users")
              .doc(res.user.uid)
              .set({
                uid: res.user.uid,
                email: email,
                fullname: fullname,
                type: "user",
                status: "active",
                countryCode: countryCode,
                phone: phone,
                phoneVerified: "false",
                emailVerified: "false",
                fcm_token: localStorage.getItem("fcm")
                  ? localStorage.getItem("fcm")
                  : "",
              });
            localStorage.setItem('emailForVerification', email);
            //this.sendVerificationEmail();
            localStorage.setItem("uid", res.user.uid);
            this.authInfo$.next(new AuthInfo(res.user.uid));
            resolve(res.user);
          }
        })
        .catch((err) => {
          this.authInfo$.next(ApisService.UNKNOWN_USER);
          reject(`login failed ${err}`);
        });
    });
  }

  public sigInWithGoogleClicked(){
    return new Promise<any>((resolve, reject) => {
      firebase.auth().signInWithRedirect(new firebase.auth.GoogleAuthProvider);
    });
  }

  
  checkFbAuth(){
    return new Promise<any>((resolve, reject) => {
    firebase.auth()
      .getRedirectResult()
      .then(result => {
        if (result && result.user != null ) {
          localStorage.setItem('uid', result.user.uid);
          this.adb
            .doc(`users/${result.user.uid}`)
            .get()
            .subscribe((response: any) => {
              if (response) {
                if (response.exists) {
                  resolve(response.data());
                }
                else {
                  const data = {
                    uid: result.user.uid,
                    email: result.user.email,
                    fullname: result.user.displayName,
                    type: "active",
                    phone: result.user.phoneNumber,
                    emailVerified: result.user.emailVerified,
                    fcm_token: localStorage.getItem("fcm")
                      ? localStorage.getItem("fcm")
                      : "",
                  }
                  this.adb
                    .doc(`users/${result.user.uid}`)
                    .set(data, { merge: false })
                    .then(res => {
                      localStorage.setItem("uid", data.uid);
                      resolve(result)
                    }).catch(err => {
                      resolve(false);
                    })
                }
              }
            });

        } else {
          resolve({result : false});
        }
      }).catch(err => {
        reject(err);
        console.log(err);
      })
    });
  }

  public sigInWithFacebookClicked(){
    return new Promise<any>((resolve, reject) => {
      firebase.auth().signInWithPopup(new firebase.auth.FacebookAuthProvider)
        .then((response) => {
          resolve(firebase.auth().getRedirectResult())
        }).catch(err => {
          reject(err);
          console.log(err);
        })
    });
  }
  public signInWithGoogle() {
    return new Promise<any>((resolve, reject) => {
      firebase.auth().signInWithPopup(new firebase.auth.GoogleAuthProvider)
        .then(result => {
          if (result && result.user != null ) {
            localStorage.setItem('uid', result.user.uid);
            this.adb
              .doc(`users/${result.user.uid}`)
              .get()
              .subscribe((response: any) => {
                if (response) {
                  if (response.exists) {
                    resolve(response.data());
                  }
                  else {
                    const data = {
                      uid: result.user.uid,
                      email: result.user.email,
                      fullname: result.user.displayName,
                      type: "active",
                      phone: result.user.phoneNumber,
                      emailVerified: result.user.emailVerified,
                      fcm_token: localStorage.getItem("fcm")
                        ? localStorage.getItem("fcm")
                        : "",
                    }
                    this.adb
                      .doc(`users/${result.user.uid}`)
                      .set(data, { merge: false })
                      .then(res => {
                        localStorage.setItem("uid", data.uid);
                        resolve(result)
                      }).catch(err => {
                        resolve(false);
                      })
                  }
                }
              });

          } else {
            resolve({result : false});
          }
        }).catch(err => {
          reject(err);
          console.log(err);
        })
    })
  }
  public signInWithFacebook() {
    return new Promise<any>((resolve, reject) => {
      firebase.auth().signInWithPopup(new firebase.auth.FacebookAuthProvider)
        .then(result => {
          if (result && result.user != null) {
            localStorage.setItem('uid', result.user.uid);
            this.adb
              .doc(`users/${result.user.uid}`)
              .get()
              .subscribe((response: any) => {
                if (response) {
                  if (response.exists) {
                    resolve(response.data());
                  }
                  else {
                    const data = {
                      uid: result.user.uid,
                      email: result.user.email,
                      fullname: result.user.displayName,
                      type: "active",
                      phone: result.user.phoneNumber,
                      emailVerified: result.user.emailVerified,
                      fcm_token: localStorage.getItem("fcm")
                        ? localStorage.getItem("fcm")
                        : "",
                    }
                    this.adb
                      .doc(`users/${result.user.uid}`)
                      .set(data, { merge: false })
                      .then(res => {
                        localStorage.setItem("uid", data.uid);
                        resolve(result)
                      }).catch(err => {
                        resolve(false);
                      })
                  }
                }
              });
          }
          else {
            resolve({result : false});
          }
        }).catch(err => {
          reject(err);
          console.log(err);
        })
    })
  }

  public sendVerificationEmail() {

    return new Promise<any>((resolve, reject) => {
      const email = this.fireAuth.auth.currentUser.email;
      var actionCodeSettings = {
        // URL you want to redirect back to. The domain (www.example.com) for this
        // URL must be whitelisted in the Firebase Console.
        url: 'https://mayoeats-41ccd.web.app/?email=' + email,
        // This must be true.
        handleCodeInApp: true,
        dynamicLinkDomain: "mayoeats.page.link"
      };

      this.fireAuth.auth.sendSignInLinkToEmail(email, actionCodeSettings)
        .then((data) => {
          resolve(true);
        }, err => {
          console.log('error sending email', err)
          reject(err);
        })
      this.fireAuth.auth.currentUser.sendEmailVerification()
        .then((data) => {
        }, err => {
          console.log('error sending email', err)
        })
    })

  }

  public singInWithPhone(countryCode, phone, recaptchaVerifier) {
    return new Promise((resolve, reject) => {
      this.fireAuth.auth.signInWithPhoneNumber("+" + countryCode + phone, recaptchaVerifier)
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          reject(err);
        })
    })
  }

  public verifyOTP(confirmationResult, verificationNumber, phone, countryCode) {
    return new Promise((resolve, reject) => {
      confirmationResult.confirm(verificationNumber)
        .then(() => {
          this.updateUserPhoneStatus(phone, countryCode)
            .then(result => {
              if (result) {
                resolve(true);
              } else {
                console.log("err");
                resolve(false);
              }
            }, err => {
              console.log(err);
              reject(err)
            })
        }, err => {
          console.log(err);

          resolve(false);
        })
        .catch(err => {
          console.log(err);

          reject(err);
        })
    })
  }

  updateUserPhoneStatus(phone, countryCode) {
    return new Promise<any>((resolve, reject) => {
      const uid = localStorage.getItem('uid');
      const userProfile = this.adb.doc(`users/${uid}`);
      userProfile.update({ phoneVerified: true, phone: phone, countryCode: countryCode })
        .then(data => {
          localStorage.setItem("uid", uid)
          //this.authInfo$.next(new AuthInfo(data.user.uid));
          resolve(true)
        }, err => {
          console.log(err);
          resolve(false);
        });
    })
  }

  public resetPassword(email: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.fireAuth.auth
        .sendPasswordResetEmail(email)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(`reset failed ${err}`);
        });
    });
  }

  public logout(): Promise<void> {
    var selectedCountry = ""
    var selectedCity = ""
    firebase.auth().signOut()
    return new Promise<any>((resolve, reject) => {
      firebase.auth().signOut()
  .then((result) => {
    // Sign-out successful.
   // this.authInfo$.next(ApisService.UNKNOWN_USER);
    //localStorage.clear();
    selectedCountry = localStorage.getItem('selectedCountry')
    selectedCity = localStorage.getItem('selectedCity')
    localStorage.clear();
    localStorage.setItem('selectedCountry', selectedCountry)
    localStorage.setItem('selectedCity', selectedCity)
    resolve (result)
  })
  .catch(function(error) {
    console.log(error)
  });
  
    });
  }

  public getProfile(id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("users")
        .doc(id)
        .get()
        .subscribe(
          (profile: any) => {
            resolve(profile.data());
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public getVenues(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("venue")
        .get()
        .subscribe(
          (venue) => {
            let data = venue.docs.map((element) => {
              let item = element.data();
              item.id = element.id;
              return item;
            });
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public getVenueDetails(id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("venue")
        .doc(id)
        .get()
        .subscribe(
          (venue: any) => {
            resolve(venue.data());
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public getVenueAddons(id): Promise<any> {
    return new Promise<any>((resolve, reject) => {

      this.adb
        .collection("addons", (ref) => ref.where("uid", "==", id).orderBy('createdAt', 'asc'))
        .get()
        .subscribe(
          (venue) => {
            var data = venue.docs.map((element) => {
              var item = element.data();
              item.id = element.id;
              return item;
            });
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public getSlotWithId(uid: any, id: any): Promise<any> {

    return new Promise<any>((resolve, reject) => {
      this.db
        .collection("timeSlot")
        .doc(uid)
        .collection("all")
        .doc(id)
        .get()
        .then(
          (data) => {
            var item = data.data();
            resolve(item);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }
  
  public getAllSlots(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("timeSlot")
        .get()
        .subscribe(
          (venue) => {
            let data = venue.docs.map((element) => {
              let item = element.data();
              item.id = element.id;
              return item;
            });
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public getSlots(uid: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.db
        .collection("timeSlot")
        .doc(uid)
        .collection("all")
        .orderBy('timeSlotValue')
        .get()
        .then(
          (data) => {
            var users = data.docs.map((doc) => {
              var item = doc.data();
              item.id = doc.id;
              return item;
            });
            resolve(users);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public updateSlot(uid, id, count): Promise<any> {

    const param = {
      uid: localStorage.getItem('vid'),
      count: count+1,
    };
  return new Promise<any>((resolve, reject) => {
    this.adb
      .collection("timeSlot")
      .doc(uid)
      .collection("all")
      .doc(id)
      .update(param)
      .then(
        (data) => {
          resolve(data);
        },
        (error) => {
          reject(error);
        }
      );
  });
}

  public getMyProfile(id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("users")
        .doc(id)
        .get()
        .subscribe(
          (users: any) => {
            resolve(users.data());
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public getVenueUser(id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("users")
        .doc(id)
        .get()
        .subscribe(
          (venue: any) => {
            resolve(venue.data());
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public getVenueCategories(id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("categories", (ref) => ref.where("uid", "==", id))
        .get()
        .subscribe(
          (venue) => {
            var data = venue.docs.map((element) => {
              var item = element.data();
              item.id = element.id;
              if (!item.subcat) {
                item.subcat = [];
              }
              return item;
            });
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public getFoods(uid: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.db
        .collection("foods")
        .doc(uid)
        .collection("all")
        .get()
        .then(
          (data) => {
            var users = data.docs.map((doc) => {
              var item = doc.data();
              item.cid.get().then(function (doc) {
                item.cid = doc.data();
                if(item.cid && doc.id)
                item.cid.id = doc.id;
              });
              item.id = doc.id;
              return item;
            });
            resolve(users);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public getMessages(id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("messages")
        .doc(id)
        .collection("chats")
        .get()
        .subscribe(
          (messages: any) => {
            let data = messages.docs.map((element) => {
              let item = element.data();
              item.id = element.id;
              return item;
            });
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public getOffers(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("offers")
        .get()
        .subscribe(
          (venue: any) => {
            // resolve(venue.data());
            let data = venue.docs.map((element) => {
              let item = element.data();
              item.id = element.id;
              return item;
            });
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }
  public offersDec(id) {

    return new Promise<any>((resolve, reject) => {
      const increment = firebase.firestore.FieldValue.increment(1);
      const userLike = this.adb.doc(`offers/${id}`);
      userLike.update({ count: increment })
        .then(data => {
          resolve(data)
        }, err => {
          reject(err);
        });
    })
  }
  public addNewAddress(uid, id, param): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("address")
        .doc(uid)
        .collection("all")
        .doc(id)
        .set(param)
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  }

  public updateAddress(uid, id, param): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("address")
        .doc(uid)
        .collection("all")
        .doc(id)
        .update(param)
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  }

  public deleteAddress(uid, id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("address")
        .doc(uid)
        .collection("all")
        .doc(id)
        .delete()
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  }

  public getMyAddress(uid: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.db
        .collection("address")
        .doc(uid)
        .collection("all")
        .get()
        .then(
          (data) => {
            var users = data.docs.map((doc) => {
              var item = doc.data();
              item.id = doc.id;
              return item;
            });
            resolve(users);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public createOrder(id, param): Promise<any> {
    param.vid = this.db.collection("venue").doc(param.vid);
    param.uid = this.db.collection("users").doc(param.uid);
    // param.dId = this.db.collection('users').doc(param.dId);
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("orders")
        .doc(id)
        .set(param)
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  }

  sendNotification(msg, title, id) {
    const body = {
      app_id: environment.onesignal.appId,
      include_player_ids: [id],
      headings: { en: title },
      contents: { en: msg },
      data: { task: msg },
    };
    const header = {
      headers: new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", `Basic ${environment.onesignal.restKey}`),
    };
    return this.http.post(
      "https://onesignal.com/api/v1/notifications",
      body,
      header
    );
  }
  sendNotifications(msg, title, ids: any[]) {
    const body = {
      app_id: environment.onesignal.appId,
      include_player_ids: ids,
      headings: { en: title },
      contents: { en: msg },
      data: { task: msg },
    };
    const header = {
      headers: new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", `Basic ${environment.onesignal.restKey}`),
    };
    return this.http.post(
      "https://onesignal.com/api/v1/notifications",
      body,
      header
    );
  }

  public getMyOrders(id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("orders", (ref) => ref.where("userId", "==", id))
        .get()
        .subscribe(
          async (venue) => {
            let data = venue.docs.map((element) => {
              let item = element.data();
              item.vid.get().then(function (doc) {
                item.vid = doc.data();
                item.vid = doc.id;
              });
              item.id = element.id;
              return item;
            });
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public getOrderById(id): Promise<any> {
    return new Promise<any>(async (resolve, reject) => {
      this.adb
        .collection("orders")
        .doc(id)
        .get()
        .subscribe(
          async (order: any) => {
            let data = await order.data();
            await data.vid.get().then(function (doc) {
              data.vid = doc.data();
              data.vid = doc.id;
            });
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  getDriverInfo(id): Promise<any> {
    return new Promise<any>(async (resolve, reject) => {
      this.adb
        .collection("users")
        .doc(id)
        .snapshotChanges()
        .subscribe(
          (data) => {
            resolve(data.payload.data());
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public updateOrderStatus(id, value): Promise<any> {
    return new Promise<any>(async (resolve, reject) => {
      this.adb
        .collection("orders")
        .doc(id)
        .update({ status: value })
        .then(async (order: any) => {
          resolve(order);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public getDrivers(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("users", (ref) => ref.where("type", "==", "delivery"))
        .get()
        .subscribe(
          async (venue) => {
            let data = venue.docs.map((element) => {
              let item = element.data();
              item.id = element.id;
              return item;
            });
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public sendOrderToDriver(id, param): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("driverOrders")
        .doc(id)
        .set(param)
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  }

  public addReview(param): Promise<any> {
    param.vid = this.db.collection("venue").doc(param.vid);
    param.uid = this.db.collection("users").doc(param.uid);
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("reviews")
        .doc(Math.random().toString())
        .set(param)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public addDriverReview(param): Promise<any> {
    param.uid = this.db.collection("users").doc(param.uid);
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("driverreviews")
        .doc(Math.random().toString())
        .set(param)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public updateVenue(informations: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("venue")
        .doc(informations.uid)
        .update(informations)
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  }

  public updateProfile(uid, param): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.db
        .collection("users")
        .doc(uid)
        .update(param)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public getMyReviews(id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("reviews", (ref) => ref.where("id", "==", id))
        .get()
        .subscribe(
          async (review) => {
            let data = review.docs.map((element) => {
              let item = element.data();
              item.id = element.id;
              if (item && item.vid) {
                item.vid.get().then(function (doc) {
                  item.vid = doc.data();
                });
              }
              return item;
            });
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public getBanners(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.adb
        .collection("banners")
        .get()
        .subscribe(
          (venue: any) => {
            // resolve(venue.data());
            let data = venue.docs.map((element) => {
              let item = element.data();
              item.id = element.id;
              return item;
            });
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  httpPost(url, body) {
    const header = {
      headers: new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", `Bearer ${environment.stripe.sk}`),
    };
    const order = this.JSON_to_URLEncoded(body);
    return this.http.post(url, order, header);
  }

  httpPostWithHeader(url, body, header) {
    const order = this.JSON_to_URLEncoded(body);
    return this.http.post(url, order, header);
  }

  httpGet(url, connectedID) {
    const header = {
      headers: new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", `Bearer ${environment.stripe.sk}`)
        .set("Stripe-Account", connectedID),

    };

    return this.http.get(url, header);
  }

  JSON_to_URLEncoded(element, key?, list?) {
    let new_list = list || [];
    if (typeof element == "object") {
      for (let idx in element) {
        this.JSON_to_URLEncoded(
          element[idx],
          key ? key + "[" + idx + "]" : idx,
          new_list
        );
      }
    } else {
      new_list.push(key + "=" + encodeURIComponent(element));
    }
    return new_list.join("&");
  }
}
